// somodernart order tab fix

const hideInputs = ({form, formName, valueToShow, hiddenBlockSelector = `.js-form-hidden`}) => {
  const hiddenBlock = form.querySelector(hiddenBlockSelector);

  form.addEventListener(`change`, () => {
    if (form[formName].value === valueToShow) {
      hiddenBlock.classList.remove(`hidden`);
    } else {
      hiddenBlock.classList.add(`hidden`);
    }
  });
};

export default hideInputs;
